export const RESTORED_LOGGED_IN = 'session/RESTORED_LOGGED_IN';
export const RESTORED_LOGGED_OUT = 'session/RESTORED_LOGGED_OUT';
export const LOGGED_IN = 'session/LOGGED_IN';
export const LOGGED_OUT = 'session/LOGGED_OUT';
export const ERROR = 'session/ERROR';

export const loggedIn = ({ accessToken, accountDomain, environment }) => ({
  type: LOGGED_IN,
  accessToken,
  accountDomain,
  environment
});

export const loggedOut = () => ({
  type: LOGGED_OUT
});

export const restoredLoggedOut = () => ({
  type: RESTORED_LOGGED_OUT
});

export const restoredLoggedIn = ({ accessToken, accountDomain, environment }) => ({
  type: RESTORED_LOGGED_IN,
  accessToken,
  accountDomain,
  environment
});

export const error = ({ error }) => ({
  type: ERROR,
  error
});
